module.exports = __webpack_public_path__ + "static/media/logoMobile.2efdfc1c.png";